// @flow
import checkResponse from 'api/checkIfResponseIsOK';
import Errors, { NetworkingError } from 'lib/errors';
import { type UploadResponse } from './ResourceTypes';

const CLOUD = '//api.cloudinary.com/v1_1/powerreviews';
const IMAGE_UPLOAD_PRESET =
  process.env.REACT_APP_VISUAL_ANSWERS_UPLOAD_PRESET_IMAGE;
const VIDEO_UPLOAD_PRESET =
  process.env.REACT_APP_VISUAL_ANSWERS_UPLOAD_PRESET_VIDEO;
// $$FlowFixMe
const UPLOAD_FOLDER = `${process.env.REACT_APP_BUILD_ENV}/visual-answers`;

function getUploadPreset(resourceType) {
  if (resourceType === 'image') {
    return IMAGE_UPLOAD_PRESET;
  } else if (resourceType === 'video') {
    return VIDEO_UPLOAD_PRESET;
  } else {
    throw new Error(`Unknown resource type: '${resourceType}'`);
  }
}

export const upload = (
  file: File | string,
  resourceType: string
): Promise<UploadResponse> => {
  if (!IMAGE_UPLOAD_PRESET || !VIDEO_UPLOAD_PRESET || !UPLOAD_FOLDER) {
    throw new Error('Environment is not configured');
  }

  const body = new FormData();
  // $$FlowFixMe
  body.append('upload_preset', getUploadPreset(resourceType));
  body.append('file', file);
  body.append('resource_type', resourceType);
  body.append('folder', UPLOAD_FOLDER);

  return fetch(`${CLOUD}/auto/upload`, {
    method: 'POST',
    body,
  })
    .then(checkResponse)
    .then(response => response.json())
    .catch((err: Error) =>
      Promise.reject(Errors.isHttpError(err) ? err : new NetworkingError())
    );
};

export const deleteByToken = (token: string): Promise<*> => {
  const body = new FormData();
  body.append('token', token);

  return fetch(`${CLOUD}/delete_by_token`, {
    method: 'POST',
    body,
  })
    .then(checkResponse)
    .catch(err => {});
};



// WEBPACK FOOTER //
// ./src/components/ContentSection/__future__/MediaUpload/cloudinaryApi.js